<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAccountSettingsStore } from '@/stores/account-settings'
import { getMyOnboardingRequests } from '@/services/onboardingApi'
import type { OnboardingRequestResponse } from '@/services/onboardingApi'
import { Clock } from '@element-plus/icons-vue'

const store = useAccountSettingsStore()
const router = useRouter()

const pendingCount = ref(0)
const onboardingRequests = ref<OnboardingRequestResponse[]>([])

onMounted(async () => {
  // Count pending membership applications
  await store.fetchMyApplications()
  const pendingApps = store.myApplications.filter(a => a.status === 'pending')
  pendingCount.value += pendingApps.length

  // Count pending onboarding requests
  const res = await getMyOnboardingRequests()
  if (res.data) {
    const pending = res.data.filter(r => r.status === 'pending')
    pendingCount.value += pending.length
    onboardingRequests.value = pending
  }
})
</script>

<template>
  <div v-if="pendingCount > 0" class="application-status-badge">
    <el-badge :value="pendingCount" :max="9" type="warning">
      <el-button
        text
        size="small"
        class="flex items-center gap-1"
        @click="router.push('/settings/organization')"
      >
        <ElIcon class="animate-pulse"><Clock /></ElIcon>
        <span class="text-xs">申请审批中</span>
      </el-button>
    </el-badge>
  </div>
</template>

<style scoped>
.application-status-badge :deep(.el-badge__content.is-fixed) {
  top: 2px;
  right: calc(2px + var(--el-badge-size) / 2);
}
</style>
